export let filterInputs = {
    boolean: [
        {
            type: 'select',
            label: 'editor.y',
            name: 'value',
            default: 'true',
            width: '100%',
            options: ['null', 'false', 'true'],
        },
    ],
    date: [
        {
            type: 'radio',
            label: 'editor.dateSelection',
            name: 'dateType',
            default: 'Period',
            width: '300px',
            group: 'dateType',
            groupKey: true,
            options: [
                { name: 'dashboard.filter.period', value: 'Period' },
                { name: 'Plage', value: 'Range' },
            ],
        },
        {
            type: 'number',
            label: 'editor.period_amount',
            class: 'limit',
            name: 'periodAmount',
            toggle: 'Period',
            group: 'dateType_Period',
            default: 1,
            width: '100%',
        },
        {
            type: 'select',
            label: 'editor.periodValue',
            name: 'periodValue',
            default: 'year',
            group: 'dateType_Period',
            width: '100%',
            options: [
                { name: 'date.year', value: 'year' },
                { name: 'date.month', value: 'month' },
                { name: 'date.week', value: 'week' },
                { name: 'date.day', value: 'day' },
                { name: 'date.hour', value: 'hour' },
                { name: 'date.minute', value: 'minute' },
                { name: 'date.second', value: 'second' },
            ],
        },
        {
            type: 'checkbox',
            label: 'dashboard.filter.rolling',
            name: 'periodRolling',
            default: false,
            group: 'dateType_Period',
            width: '100%',
        },
        {
            type: 'number',
            label: 'editor.periodOffset',
            class: 'limit',
            name: 'offsetAmount',
            toggle: 'Period',
            group: 'dateType_Period',
            default: 0,
            width: '100%',
        },
        {
            type: 'select',
            label: 'editor.offsetValue',
            name: 'offsetValue',
            default: 'day',
            group: 'dateType_Period',
            width: '100%',
            options: [
                { name: 'date.year', value: 'year' },
                { name: 'date.month', value: 'month' },
                { name: 'date.week', value: 'week' },
                { name: 'date.day', value: 'day' },
                { name: 'date.hour', value: 'hour' },
                { name: 'date.minute', value: 'minute' },
                { name: 'date.second', value: 'second' },
            ],
        },
        {
            type: 'datetime-local',
            label: 'editor.rangeMin',
            class: 'limit',
            toggle: 'Range',
            name: 'min',
            default: 0,
            group: 'dateType_Range',
            width: '140px',
        },
        {
            type: 'checkbox',
            label: 'editor.inclusive',
            name: 'eqMin',
            group: 'dateType_Range',
            width: '100%',
        },
        {
            type: 'datetime-local',
            label: 'editor.rangeMax',
            class: 'limit',
            name: 'max',
            default: 0,
            group: 'dateType_Range',
            width: '140px',
        },
        {
            type: 'checkbox',
            label: 'editor.inclusive',
            name: 'eqMax',
            group: 'dateType_Range',
            width: '100%',
        },
        {
            type: 'checkbox',
            label: 'editor.useHoursInterval',
            name: 'useHoursInterval',
            group: 'useHours',
            groupKey: true,
            width: '300px',
        },
        {
            type: 'select',
            label: 'editor.minHour',
            class: 'limit',
            hourMode: true,
            name: 'minHour',
            default: 0,
            width: '110px',
            group: 'useHours',
            options: Array.from({ length: 24 }, (_, i) => i),
        },
        {
            type: 'select',
            label: 'editor.minMinute',
            class: 'limit',
            name: 'minMinute',
            default: 0,
            width: '110px',
            group: 'useHours',
            options: Array.from({ length: 60 }, (_, i) => i),
        },
        // {
        //     type: "checkbox",
        //     label: "editor.use",
        //     name: "useMin",
        //     width: "100%"
        // },
        {
            type: 'select',
            label: 'editor.maxHour',
            class: 'limit',
            name: 'maxHour',
            hourMode: true,
            default: 23,
            width: '110px',
            group: 'useHours',
            options: Array.from({ length: 24 }, (_, i) => i),
        },
        {
            type: 'select',
            label: 'editor.maxMinute',
            class: 'limit',
            name: 'maxMinute',
            default: 59,
            width: '110px',
            group: 'useHours',
            options: Array.from({ length: 60 }, (_, i) => i),
        },
        // {
        //     type: "checkbox",
        //     label: "editor.use",
        //     name: "useMax",
        //     width: "100%"
        // },
    ],
    number: [
        {
            type: 'checkbox',
            label: 'dashboard.filter.useMin',
            name: 'useMin',
        },
        {
            type: 'number',
            label: 'units.min',
            class: 'limit',
            name: 'min',
            default: 0,
            width: '100%',
        },
        {
            type: 'checkbox',
            label: 'editor.inclusive',
            name: 'eqMin',
            width: '100%',
        },
        {
            type: 'checkbox',
            label: 'dashboard.filter.useMax',
            name: 'useMax',
        },
        {
            type: 'number',
            label: 'units.max',
            class: 'limit',
            name: 'max',
            default: 0,
            width: '100%',
        },
        {
            type: 'checkbox',
            label: 'editor.inclusive',
            name: 'eqMax',
            width: '100%',
        },
    ],
    string: [
        {
            type: 'radio',
            label: 'editor.use',
            name: 'use',
            default: 'list',
            options: [
                { name: 'datepicker.customRangeLabel', value: 'custom' },
                { name: 'form.select', value: 'list' },
            ],
            width: '100%',
        },
        {
            type: 'select',
            label: 'dashboard.filter.field_value',
            multiple: true,
            options: [],
            name: 'values',
            width: '100%',
        },
        {
            type: 'text',
            label: 'editor.customValues',
            name: 'value',
            width: '100%',
        },
    ],
    objectid: [
        {
            type: 'radio',
            label: 'editor.use',
            name: 'use',
            default: 'list',
            options: [
                { name: 'datepicker.customRangeLabel', value: 'custom' },
                { name: 'form.select', value: 'list' },
            ],
            width: '100%',
        },
        {
            type: 'select',
            label: 'dashboard.filter.field_value',
            multiple: true,
            options: [],
            name: 'values',
            width: '100%',
        },
        {
            type: 'text',
            label: 'editor.customValues',
            name: 'value',
            width: '100%',
        },
    ],
};